if (!customElements.get('collection-slider')) {
  class CollectionSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const sliders = this.querySelectorAll('.swiper-collection');

      sliders.forEach((slider) => {
        const sliderId = slider.getAttribute('id'); // Отримуємо унікальний ID слайдера
        const prevBtn = this.querySelector(`.swiper-button-prev[data-slider-id="${sliderId}"]`);
        const nextBtn = this.querySelector(`.swiper-button-next[data-slider-id="${sliderId}"]`);

        new Swiper(`#${sliderId}`, {
          slidesPerView: 2,
          spaceBetween: 30,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
          breakpoints: {
            991: {
              slidesPerView: 4,
            },
            749: {
              slidesPerView: 2.5,
            }
          }
        });
      });
    }
  }

  customElements.define('collection-slider', CollectionSlider);
}